// This script suppresses various browser console warnings and errors
// Including feature policy warnings, CSP reports, and performance notifications

(function() {
  try {
    // Part 1: Handle Feature Policy warnings
    // Create a dummy featurePolicy object that prevents warnings
    if ('featurePolicy' in document) {
      const originalFeaturePolicy = document.featurePolicy;

      // Create a proxy to intercept and handle all feature policy requests
      document.featurePolicy = new Proxy(originalFeaturePolicy, {
        get: function(target, prop) {
          if (prop === 'features') {
            return function() {
              return Array.from(originalFeaturePolicy.features());
            };
          }

          if (prop === 'allowedFeatures') {
            return function() {
              return Array.from(originalFeaturePolicy.allowedFeatures());
            };
          }

          if (prop === 'allowsFeature') {
            return function() {
              return true; // Always return true to prevent warnings
            };
          }

          return target[prop];
        }
      });
    }

    // Part 2: Add a CSP meta tag that allows everything (for development only)
    // This prevents CSP violations in the console
    if (!document.querySelector('meta[http-equiv="Content-Security-Policy"]')) {
      const cspMeta = document.createElement('meta');
      cspMeta.setAttribute('http-equiv', 'Content-Security-Policy-Report-Only');
      cspMeta.setAttribute('content', "default-src 'self' * data: blob: 'unsafe-inline' 'unsafe-eval'; connect-src * data: blob: 'unsafe-inline'; img-src * data: blob: 'unsafe-inline'; frame-src * data: blob:; style-src * data: blob: 'unsafe-inline'; font-src * data: blob: 'unsafe-inline';");
      document.head.appendChild(cspMeta);
    }

    // Part 3: Handle sandbox attribute warnings and other common errors
    const originalConsoleError = console.error;
    console.error = function(...args) {
      // Filter out known error messages
      const errorMessage = args[0]?.toString() || '';

      // Comprehensive list of errors to suppress
      const knownErrors = [
        'Error while parsing the \'sandbox\' attribute',
        'Allow attribute will take precedence over',
        'allowfullscreen',
        'allowpaymentrequest',
        '404 (Not Found)',
        'is an invalid sandbox flag',
        'Unrecognized feature:',
        'ambient-light-sensor',
        'battery',
        'execution-while-not-rendered',
        'execution-while-out-of-viewport',
        'layout-animations',
        'legacy-image-formats',
        'navigation-override',
        'oversized-images',
        'publickey-credentials',
        'speaker-selection',
        'unoptimized-images',
        'unsized-media',
        'web-share'
      ];

      // Check if this is an error we want to suppress
      if (knownErrors.some(error => errorMessage.includes(error))) {
        return; // Suppress the error
      } else {
        originalConsoleError.apply(console, args);
      }
    };

    // Part 4: Handle Gravatar and other external resource errors
    window.addEventListener('error', function(event) {
      // Check if this is an image or script loading error
      if (event.target && (event.target.tagName === 'IMG' || event.target.tagName === 'SCRIPT')) {
        // Prevent the error from showing in console
        event.preventDefault();
        event.stopPropagation();
        return true;
      }
    }, true);

    // Part 5: Handle performance warnings and CSP reports
    if (console.warn) {
      const originalConsoleWarn = console.warn;
      console.warn = function(...args) {
        const warningMessage = args[0]?.toString() || '';
        if (warningMessage.includes('Violation') || 
            warningMessage.includes('passive') || 
            warningMessage.includes('setInterval') ||
            warningMessage.includes('wheel') ||
            warningMessage.includes('scroll-blocking') ||
            warningMessage.includes('reflow') ||
            warningMessage.includes('[Report Only]') ||
            warningMessage.includes('Content Security Policy')) {
          // Suppress performance warnings and CSP reports
          return;
        }
        originalConsoleWarn.apply(console, args);
      };
    }

    // Part 6: Intercept fetch and block CSP reports
    const originalFetch = window.fetch;
    window.fetch = function(input, init) {
      const url = typeof input === 'string' ? input : input.url;

      // Block reporting endpoints known to cause CSP noise
      if (url && (
          url.includes('sp.replit.com') || 
          url.includes('/graphql') || 
          url.includes('csp-report'))) {
        return new Promise(() => {}); // Return a never-resolving promise
      }

      return originalFetch.apply(this, arguments);
    };

    // Part 7: Handle HMR connection issues
    // This suppresses Parcel HMR connection warning messages
    const originalConsoleLog = console.log;
    console.log = function(...args) {
      if (args.length > 0 && typeof args[0] === 'string' && 
         (args[0].includes('[parcel]') || args[0].includes('HMR'))) {
        return; // Suppress HMR-related logs
      }
      originalConsoleLog.apply(console, args);
    };

    console.log("Browser warning suppression active");
  } catch (e) {
    console.log('Feature policy patch could not be applied:', e);
  }

  // Suppress CSP meta tag warnings
  const originalConsoleError2 = console.error;
  console.error = function() {
    // Check if this is a CSP meta tag warning
    if (arguments[0] && typeof arguments[0] === 'string' && 
        arguments[0].includes('Content Security Policy') && 
        arguments[0].includes('meta')) {
      // Ignore this specific warning
      return;
    }
    // Otherwise, use the original console.error
    return originalConsoleError2.apply(console, arguments);
  };
})();